import { decodeKeyword } from '../utils/decodeUtil';
import { KNI_SEARCHFLG_ALL } from '../constants/properties/const';
import { QueryParams } from '../constants/queryParams';
import { isHalfNum } from '../utils/stringUtil';

// サーバでリクエストを受け取り後のバリデーション
export const validateParams = (param: QueryParams) => {
  const validatedParam = { ...param };

  if (param.page) {
    // 正の整数でない場合は削除
    if (!/^[1-9]\d*$/.test(param.page)) {
      delete validatedParam.page;
    }
  }

  if (param.preBtn) {
    // 正の整数1,2,3でない場合は削除
    if (!/^[1-3]\d*$/.test(param.preBtn)) {
      delete validatedParam.preBtn;
    }
  }

  if (param.k) {
    const decodeK = decodeKeyword(param.k);
    if (decodeK) {
      if (decodeK.trim() === '') {
        delete validatedParam.k;
        delete validatedParam.kwc;
      } else {
        validatedParam.k = decodeK;
        if (!param.kwc || !isHalfNum(param.kwc)) {
          // 検索範囲フラグが存在しない場合
          // 検索範囲フラグが半角数字以外の場合
          validatedParam.kwc = KNI_SEARCHFLG_ALL;
        }
      }
    }
  } else {
    // kが無い場合はkwcを削除
    if (param.kwc) {
      delete validatedParam.kwc;
    }
    if (param.kw) {
      // kクエリが無くkwクエリのみ存在する場合は、その値をkクエリとして扱う
      // kwcは実際の値に関わらず"1"固定とする
      const decodeKW = decodeKeyword(param.kw);
      if (decodeKW) {
        if (decodeKW.trim() === '') {
          delete validatedParam.kwc;
        } else {
          validatedParam.k = decodeKW;
          validatedParam.kwc = KNI_SEARCHFLG_ALL;
        }
        delete validatedParam.kw;
      }
    }
  }

  if (param.feak) {
    const decodeFeak = decodeKeyword(param.feak);
    if (decodeFeak) {
      if (decodeFeak.trim() === '') {
        delete validatedParam.feak;
        delete validatedParam.feakwc;
      } else {
        validatedParam.feak = decodeFeak;
        if (!param.feakwc || !isHalfNum(param.feakwc)) {
          // 検索範囲フラグが存在しない場合
          // 検索範囲フラグが半角数字以外の場合
          validatedParam.feakwc = KNI_SEARCHFLG_ALL;
        }
      }
    }
  } else {
    // feakが無い場合はfeakwcを削除
    // eslint-disable-next-line no-lonely-if
    if (param.feakwc) {
      delete validatedParam.feakwc;
    }
  }

  if (param.ni) {
    const decodeNI = decodeKeyword(param.ni);
    if (decodeNI) {
      if (decodeNI.trim() === '') {
        delete validatedParam.ni;
        delete validatedParam.niwc;
      } else {
        validatedParam.ni = decodeNI;
        if (!param.niwc || !isHalfNum(param.niwc)) {
          // 検索範囲フラグが存在しない場合
          // 検索範囲フラグが半角数字以外の場合
          validatedParam.niwc = KNI_SEARCHFLG_ALL;
        }
      }
    }
  } else if (param.niwc) {
    delete validatedParam.niwc;
  }

  if (param.feani) {
    const decodeFeaNI = decodeKeyword(param.feani);
    if (decodeFeaNI) {
      if (decodeFeaNI.trim() === '') {
        delete validatedParam.ni;
        delete validatedParam.niwc;
      } else {
        validatedParam.feani = decodeFeaNI;
        if (!param.feaniwc || !isHalfNum(param.feaniwc)) {
          // 検索範囲フラグが存在しない場合
          // 検索範囲フラグが半角数字以外の場合
          validatedParam.feaniwc = KNI_SEARCHFLG_ALL;
        }
      }
    }
  } else if (param.feaniwc) {
    delete validatedParam.feaniwc;
  }
  return validatedParam;
};

/**
 * 検索可能な年収の指定となっているか判定する
 * @param {number} upper 最低年収
 * @param {number} lower 最高年収
 * @returns {boolean}
 */
export const canSearchSalary = (lower: number, upper: number) => {
  const salaryRange = [lower, upper];

  // どちらかが未設定('0')の場合はOK
  if (salaryRange?.includes(0)) {
    return true;
  }

  // 以下の場合はNG
  // - 最低年収が最高年収より高い
  // - 最低年収と最高年収が同じ
  const LOWER = 0;
  const UPPER = 1;

  if (salaryRange[LOWER] >= salaryRange[UPPER]) {
    return false;
  }

  return true;
};
